import { theme } from '@octane/spark'

// Accent color for form field action icons (SSN eye toggle, add/remove other income).
// Default Octane blue; Buffalo variant overrides to brand yellow #FFD200.
export const fieldActionIconColor: string = theme.colors.brand.primary
